export default [
    {
      path: "/user/ticket/:active",
      name: "ticket",
      meta: {
        title: "商城券包",
      },
      component: () => import("./MyTicket"),
    },
  ];